<nav class="vw-nav" [attr.aria-label]="'verwaltung.nav.ariaLabel' | translate">
  <div class="vw-nav__kopf">
    <div class="vw-nav__kopf-titel">{{ 'verwaltung.nav.kopf' | translate }}</div>
    <div class="vw-nav__firmenname" data-testid="vw-firmenname">{{ firmenname() }}</div>
  </div>
  @for (gruppe of gruppen; track gruppe.label) {
    <div class="vw-nav__gruppe">
      <div class="vw-nav__gruppe-label">{{ gruppe.label | translate }}</div>
      @for (bereich of gruppe.bereiche; track bereich.id) {
        @let istAktiv = bereich.id === aktiv();
        @let n = anzahl(bereich.badge);
        <button
          type="button"
          class="vw-nav__eintrag"
          [class.vw-nav__eintrag--aktiv]="istAktiv"
          [attr.aria-current]="istAktiv ? 'page' : null"
          [attr.data-testid]="'vw-nav-' + bereich.id"
          (click)="waehlen.emit(bereich.id)"
        >
          <mat-icon class="vw-nav__icon" aria-hidden="true">{{ bereich.icon }}</mat-icon>
          <span class="vw-nav__label">{{ bereich.titel | translate }}</span>
          @if (bereich.badge && n > 0) {
            <span class="vw-nav__badge" [attr.data-testid]="'vw-nav-badge-' + bereich.id">
              <span aria-hidden="true">{{ n }}</span>
              <span class="sr-only">{{ badgeText(bereich.badge, n) | translate: { n } }}</span>
            </span>
          }
        </button>
      }
    </div>
  }
</nav>
